module.exports = __webpack_public_path__ + "static/media/1026165.324dc46b.jpg";